var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"return-home"},[_c('router-link',{attrs:{"to":"/"}},[_c('i')])],1)}
var staticRenderFns = []
export { render, staticRenderFns }